let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ecN0e")).then(() => parcelRequire('56nbu'));